import { render, staticRenderFns } from "./AvailableProductView.vue?vue&type=template&id=f997be58&"
import script from "./AvailableProductView.vue?vue&type=script&lang=js&"
export * from "./AvailableProductView.vue?vue&type=script&lang=js&"
import style0 from "./AvailableProductView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports